import { PanelProps } from '@blueprintjs/core';
import * as React from 'react';

import { InlineEditableLabel } from 'src/components/InlineEditableLabel';
import { TEST_IDS } from 'src/constants/testIds';
import { useAddLocalModel } from 'src/containers/ProjectModelDialog/hooks/useAddLocalModel';
import { useLocalModel } from 'src/containers/ProjectModelDialog/hooks/useLocalModelValue';
import * as copy from 'src/templates/copy';

export type LocalModelPanelProps = {
  // empty
};

export const LocalModelPanel: React.VFC<
  PanelProps<LocalModelPanelProps>
> = () => {
  const { nameValidationError, namespaceValidationError } = useAddLocalModel();
  const {
    isNameEdited,
    isNamespaceEdited,
    name,
    namespace,
    setName,
    setNamespace,
  } = useLocalModel();

  return (
    <div className="sd-model-local-panel">
      <InlineEditableLabel
        label={copy.components.projectModelDialog.localModelPanel.name}
        monospaceText={false}
        onBlur={() => {
          if (!name) {
            setName(
              copy.components.projectModelDialog.localModelPanel.nameExampleText
            );
          }
        }}
        onSetValue={setName}
        // use calculated value
        onValidate={() =>
          !isNameEdited || !nameValidationError ? '' : nameValidationError
        }
        placeholder=""
        testId={TEST_IDS.projectModelDialog.localModelPanel.nameInput}
        value={name}
      />
      <InlineEditableLabel
        label={copy.components.projectModelDialog.localModelPanel.namespace}
        onSetValue={setNamespace}
        // use calculated value
        onValidate={() => (!isNamespaceEdited ? '' : namespaceValidationError)}
        placeholder=""
        testId={TEST_IDS.projectModelDialog.localModelPanel.namespaceInput}
        value={namespace}
      />
    </div>
  );
};
